export { toSadaratPartialUpdate } from "@/utils/raza-event-sadarat-update";

/** PUT body for ohbat partial Edit-in-Dialog (khidmatguzar ITS). */
export function toKhidmatguzarPartialUpdate(data: Record<string, unknown>): {
  khidmatguzarItsNo: string | null;
} {
  return {
    khidmatguzarItsNo:
      typeof data.khidmatguzarItsNo === "string" ? data.khidmatguzarItsNo.trim() || null : null,
  };
}

/** PUT body for ohbat partial Edit-in-Dialog (zakereen ITS). */
export function toZakereenPartialUpdate(data: Record<string, unknown>): {
  zakereenItsNo: string | null;
} {
  return {
    zakereenItsNo:
      typeof data.zakereenItsNo === "string" ? data.zakereenItsNo.trim() || null : null,
  };
}
